import { render, staticRenderFns } from "./DragSelectorItem.vue?vue&type=template&id=9bc3e45a&scoped=true&"
import script from "./DragSelectorItem.vue?vue&type=script&lang=js&"
export * from "./DragSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./DragSelectorItem.vue?vue&type=style&index=0&id=9bc3e45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc3e45a",
  null
  
)

export default component.exports